import React, { useEffect } from "react";
import styles from "./SelectNextStep.module.scss";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../routes";
import CommonRadioButton from "../../common/components/new/radio-button/CommonRadioButton";
import { GreenPower, Plugin, Store } from "../../assets/icons";
import { useLazyGetCustomerInfoQuery } from "../../service/customer-service";
import { toast } from "react-toastify";

type Props = {};

const SelectNextStep: React.FC<Props> = (props: Props) => {
	const navigate = useNavigate();

	const [getCustomerInfo, { data }] = useLazyGetCustomerInfoQuery();

	const onSubmit = (value: string) => {
		switch (value) {
			case "Visit Store":
				navigate(ApplicationRoutes.STORE_FRONT);
				break;
			case "Generate Power Need":
				navigate(ApplicationRoutes.RECOMMENDATION);
				break;
			case "Go to Dashboard":
				navigate(`/${ApplicationRoutes.CUSTOMER_BASE}/${ApplicationRoutes.DASHBOARD}`);
				break;
		}
	};

	useEffect(() => {
		getCustomerInfo()
		.unwrap()
		.then()
		.catch(
			(err) => {
				toast.error(err.data?.title || "Something went wrong");
			}
		);
	}, [getCustomerInfo]);

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>Hello {data?.firstName},</h1>
			<h4 className={styles.subtitle}>What would you love to do next?</h4>
			<div className={styles.content}>
				<div className={styles.listContainer}>
					<CommonRadioButton
						value={"Visit Store"}
						title="Visit Store"
						description="Optimize energy supply for sustainability."
						onChangeValue={onSubmit}
					>
						<Store />
					</CommonRadioButton>
					<CommonRadioButton
						value={"Generate Power Need"}
						title="Generate Power Need"
						description="At Solar Marketplace, we believe in harnessing all."
						onChangeValue={onSubmit}
					>
						<Plugin />
					</CommonRadioButton>
					<CommonRadioButton
						value={"Go to Dashboard"}
						title="Go to Dashboard"
						description="Navigate to the dashboard with just one click."
						onChangeValue={onSubmit}
					>
						<GreenPower />
					</CommonRadioButton>
				</div>
			</div>
		</div>
	);
};

export default SelectNextStep;
